import type { DimensionsForTracking } from '../getAddToBasketColorString/getAddToBasketColorString';

export function getAddToBasketVariantString(dimensions: DimensionsForTracking) {
  const variant: string[] = [];
  dimensions.forEach(({ values }) => {
    values.forEach(({ isSelected, displayText }) => {
      if (isSelected === true && displayText) {
        variant.push(displayText);
      }
    });
  });

  return variant.join(', ');
}
